var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoloExclusiveBarDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8215 31.4314H50.9638V55.4462C50.9638 57.9315 48.9491 59.9462 46.4638 59.9462H31.3215C28.8363 59.9462 26.8215 57.9315 26.8215 55.4462V31.4314Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3835 24.0339C23.5737 25.7829 24.6817 30.9314 26.868 31.478H32V39C32 42.2794 35.8932 42.2794 36 39V31.478H50.9172C54.1966 28.1986 51.4637 23.4873 47.5135 23.4873C47.0763 21.7383 44.8316 21.3011 43.6875 21.8476C41.064 18.7868 37.4931 20.2079 36.0355 21.3011C31.663 19.5521 29.1123 22.3942 28.3835 24.0339Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8706 35.804H55.2089C57.6942 35.804 59.7089 37.8187 59.7089 40.304V47.7942C59.7089 50.2795 57.6942 52.2942 55.2089 52.2942H50.8706V35.804Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8706 37.9902H55.0226C56.4033 37.9902 57.5226 39.1095 57.5226 40.4902V47.6079C57.5226 48.9887 56.4033 50.1079 55.0226 50.1079H50.8706V37.9902Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1472 44.21L40.9678 43.8547L39.3076 40.3208C39.1913 40.0734 38.8086 40.0734 38.6924 40.3208L37.0322 43.8546L32.8528 44.21C32.5601 44.2349 32.4419 44.5685 32.6627 44.7463L35.816 47.2857L34.8932 51.0391C34.8286 51.3019 35.1382 51.5081 35.3909 51.3706L39 49.4062L42.6091 51.3706C42.8618 51.5082 43.1714 51.3019 43.1068 51.0391L42.1839 47.2857L45.3373 44.7463C45.5581 44.5685 45.4398 44.2349 45.1472 44.21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoloExclusiveBarDeals);
export default __webpack_public_path__ + "static/media/Volo_exclusive_bar_deals.03f8b00f7f29afb21037610b23d93b97.svg";
export { ForwardRef as ReactComponent };